import React from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { questionShape } from "utils/propTypeShapes"
import AnsweredFormOverviewQuestion from "./AnsweredFormOverviewQuestion"

const AnsweredFormOverviewQuestions = ({ questions = [] }) => {
  if (isEmpty(questions)) return null

  return (
    <ol>
      {
        questions.map((question) => (
          <li key={question.uuid}>
            <AnsweredFormOverviewQuestion question={question} />
          </li>
        ))
      }
    </ol>
  )
}

AnsweredFormOverviewQuestions.propTypes = {
  questions: types.arrayOf(questionShape),
}

export default AnsweredFormOverviewQuestions
